import React from "react";

import "./styles/leadershipStats.css";

const LeadershipStats = () => {
	const stats = [
		{
			number: "30+",
			label: "Engineers Led",
			description: "Across teams and years",
		},
		{
			number: "25+",
			label: "Engineers Mentored",
			description: "From junior to senior",
		},
		{
			number: "10+",
			label: "Years in Regulated Finance",
			description: "Where being wrong is expensive",
		},
		{
			number: "5",
			label: "Industries Shipped In",
			description: "Finance to ed-tech",
		},
	];

	return (
		<div className="leadership-stats">
			<h3 className="stats-title">By the numbers</h3>
			<div className="stats-grid">
				{stats.map((stat, index) => (
					<div
						key={index}
						className={`stat-item animate-fade-up animate-delay-${
							(index + 1) * 200
						}`}
					>
						<div className="stat-number">{stat.number}</div>
						<div className="stat-label">{stat.label}</div>
						<div className="stat-description">
							{stat.description}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default LeadershipStats;
